import { createContext, useState, Dispatch, SetStateAction } from 'react';

type GalleryContextType = {
  galleryActive: boolean;
  setGalleryActive: Dispatch<SetStateAction<boolean>>;
  fullScreenActive: boolean;
  setFullScreenActive: Dispatch<SetStateAction<boolean>>;
};

export const GalleryContext = createContext<GalleryContextType>({
  galleryActive: false,
  setGalleryActive: () => {},
  fullScreenActive: false,
  setFullScreenActive: () => {},
});

export const useGalleryContext = () => {
  const [galleryActive, setGalleryActive] = useState(false);
  const [fullScreenActive, setFullScreenActive] = useState(false);

  return {
    galleryActive,
    setGalleryActive,
    fullScreenActive,
    setFullScreenActive,
  };
};
